module.exports = "/assets/data/84929b060f33afaaa60fd9cc2f21a955-NE65.data.json";